<script setup lang="ts">
    import { inject } from 'vue';
    import Tabs, { tab } from '@shared/components/Tabs.vue';
    import AddedSponsors from '@views/Event/AddedSponsors.vue';
    import Sponsors from '@views/Event/Sponsors.vue';
    import { handleAddSponsorToEvent } from '@views/Event/SpeakersAndSponsorsListUtils';
    import { type Sponsor } from '@views/Event/EventTypes';
    import { useEventMembers } from '@views/Event/EventEditor/use-event-members';
    import { canEditKey } from '@views/Event/EventEditor/event-editor-keys';

    const props = defineProps<{
        eventId: string;
    }>();

    const canEdit = inject(canEditKey)!;

    const { state, customHeader, onLoaded, onAdded, onRemoved, onAddToEvent, onUpdateCustomHeader } = useEventMembers<Sponsor>({
        eventId: () => props.eventId,
        idOf: (sponsor) => sponsor.SponsorId,
        addToEvent: handleAddSponsorToEvent,
        headerProperty: 'CustomSponsorHeader',
        headerLabel: $Resources.SponsorHeading,
    });
</script>

<template>
    <Tabs navClass="tabs list-unstyled">
        <tab :title="$Resources.SponsorHeading">
            <AddedSponsors
                :eventId="eventId"
                :addedSponsors="state.added"
                :customSponsorHeader="customHeader"
                :updateEnabled="canEdit"
                @addToEvent="onAddToEvent"
                @sponsorsLoaded="onLoaded"
                @sponsorRemoved="onRemoved"
                @updateCustomSponsorHeader="onUpdateCustomHeader"></AddedSponsors>
        </tab>
        <tab :title="$Resources.AllSponsorsHeading">
            <Sponsors
                :addToEvent="true"
                :eventId="eventId"
                :eventSponsorIds="state.eventIds"
                :updateEnabled="canEdit"
                @sponsorAdded="onAdded"></Sponsors>
        </tab>
    </Tabs>
</template>
